<template>
  <div>
    <h1>{{ event.name }}</h1>
    <p>
      <br>
      <span class="date">{{ event.date | moment }}</span>
      <span class="location">{{ event.location }}</span>
    </p>
    <blockquote v-html="event.description"></blockquote>
  </div>
</template>

<script>
import Moment from 'moment'

export default {
  name: 'Event',
  props: ['event'],
  filters: {
    moment: function(date) {
      return Moment(date).format('MMMM D, YYYY @ h:mma')
    }
  }
}
</script>

<style lang="less" scoped>
div {
  margin-bottom: 3em;
  margin-top: 3em;

  h1 {
    margin-bottom: -1em;
  }

  p {
    font-weight: bold;

    span {
      margin: 0 0.333em;
      padding: 0 0.333em;
    }

    .date {
      background-color: #c72b85;
      color: white;
      transform: rotate(-2deg);
      display: inline-block;
      font-size: 0.8em;
    }

    .location {
      font-size: 0.8em;
      background-color: #5d1da2;
      color: white;
      transform: rotate(-2deg);
      display: inline-block;
    }
  }

  blockquote {
    font-style: italic;
  }
}
</style>
